module.exports = {
  GOOGLE_API_KEY_IOS: 'AIzaSyBfPN6pfxxgYGG10KN3bHmyhrOexh1wQj4',
  GOOGLE_API_KEY_ANDROID: 'AIzaSyAeqyD51jNlZRHYjGnTPm3QN0WjudPAhlY',
  GOOGLE_API_KEY_WEB: 'AIzaSyCzFLYizo54pCoy9wO8rcAJZfWXAr7B7Aw',
  GOOGLE_ANALYTICS_KEY: 'UA-145129453-1',
  GOOGLE_TAG_MANAGER_ID_WEB: 'GTM-M4GS8JB',
  STRIPE_PUBLISHABLE_KEY: 'pk_test_u2vKqrv2gG3DIHUSDCfGfSJ6',
  envSpecific: {
    dev: {
      APP_IDENTIFIER: 'com.digicelgroup.wizzee.dev',
      PRODUCT_BUNDLE_DISPLAY_NAME: 'Wizzee Dev',
      APP_STORE_ID: '6478923636',
      DEEPLINK_URL: 'kaizendev://',
      APPLINK_URL: 'https://api-kaizen.tparici.com',
      CODEPUSH_DEPLOYMENT_KEY: {
        ios: 'KZf3Lq4y-6uztS8boTRRJ-SKQU9OHJgb9WzV4',
        android: '6LLYA0tW0fBWvQCMGhpSW5joBDPcSkJI5bMVN',
      },
      WEB_HEADER_LOGO_REDIRECTION_URL:
        'https://api-kaizen.tparici.com/assets/index.html',
    },
    stage: {
      APP_IDENTIFIER: 'com.digicelgroup.wizzee.stage',
      APP_STORE_ID: '6478923636',
      PRODUCT_BUNDLE_DISPLAY_NAME: 'Wizzee Stage',
      DEEPLINK_URL: 'kaizenstage://',
      APPLINK_URL: 'https://api-kaizen-stage.tparici.com',
      STRIPE_PUBLISHABLE_KEY: 'pk_test_3cOazcZg4LwgM7WTUyXUynsY00F3qBuQS6',
      WEB_HEADER_LOGO_REDIRECTION_URL:
        'https://api-kaizen-stage.tparici.com/assets/index.html',
    },
    prod: {
      APP_IDENTIFIER: 'com.digicelgroup.wizzee',
      APP_STORE_ID: '1464160388',
      PRODUCT_BUNDLE_DISPLAY_NAME: 'Wizzee',
      DEEPLINK_URL: 'wizzee://',
      APPLINK_URL: 'https://app.wizzee.fr',
      GOOGLE_ANALYTICS_KEY: 'UA-77420295-8',
      GOOGLE_API_KEY_IOS: 'AIzaSyAm4aVxRY1AZsfDL1XHMrOnaA5JA84IQEM',
      GOOGLE_API_KEY_ANDROID: 'AIzaSyD7hRBT8TbU0Ye341-PtcTfjlOP-ZvGE-k',
      GOOGLE_API_KEY_WEB: 'AIzaSyBl1VpWAbQESxHTVunxQNH5n4WDW3uW31c',
      STRIPE_PUBLISHABLE_KEY: 'pk_live_o5nROHGN5FQfn4Zx0bfmOyOe00ZIOh3ZNP',
      WEB_HEADER_LOGO_REDIRECTION_URL:
        'https://app.wizzee.fr/assets/index.html',
    },
  },
};
